// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import * as React from "react";
import { makeStyles, Button,} from '@material-ui/core';
import { TextField, FunctionField, List, Datagrid, TopToolbar } from 'react-admin'
import Pagination from "../Components/Pagination";

// const discountTypes = {
//     FINAL_PRICE:
//     {
//         en: 'FINAL_PRICE',
//         fa: 'قیمت نهایی'
//     }
// };

// const convertToShamsi = (date: any) => {
//     let dateP = new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", { timeZone: 'IRAN' })).toLocaleString('fa-IR-u-nu-latn')
//     return dateP;
// }

const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 650,
    }
}));

const ListActions = (props: any) => {
    return (
        <TopToolbar>
            {/* <Button startIcon={<AttachMoneyIcon style={{ marginLeft: '5px' }} />} color="primary" href="/manager/#/register-settlement/">ثبت واریزی</Button> */}
            <Button color="primary" href={process.env.REACT_APP_AUTH_PUBLIC_PATH + "/#/create-campaign"}>جدید</Button>
            {/* <CreateButton label="جدید" />
            <ExportButton label="خروجی اکسل" /> */}
            {/* Add your custom actions */}
        </TopToolbar>
    )
};


export const CampaignList = (props: ListProps): React.ReactElement => {
    const [utm_query,setUtm_Query]=React.useState('');
    const searchQuery = (e)=>{
        e.preventDefault()
        window.location.href = `${process.env.REACT_APP_AUTH_PUBLIC_PATH}/#/edit-campaign?id=${utm_query}`
    }
    return (
        <>
            <form action="">
            <div style={{ display: "flex", alignItems: "center", width: "100%", flexDirection: "row",marginTop:"10px" }} >
             <input
                  style={{ fontFamily: 'IranSans-Light',padding:"8px 14px",marginLeft:"10px" }}
                  name="utm_query"
                  type="textbox"
                  placeholder="کد کمپین"
                  dir="ltr"
                  value={utm_query}
                  onChange={(e)=>setUtm_Query(e.target.value)}
                />
                <Button       
                  type="submit"
                  color="primary"
                  variant="contained"
                  onClick={(e)=>searchQuery(e)}
                >
                جستجو
                </Button>
            </div>
            </form>
            <List
                {...props}
                bulkActionButtons={false}
                title={"لیست کمپینها"}
                perPage={50}
                pagination={<Pagination />}
                sort={{ field: 'updatedAt', order: 'DESC' }}
                actions={<ListActions />}
            >
                <Datagrid rowClick="show">
                    <TextField
                        label="کد کمپین"
                        source="utmCampaign"
                    />

                    <TextField
                        label="نام"
                        source="name"
                    />

                    <FunctionField
                        label=""
                        render={(record: any) => <Button color="primary" href={process.env.REACT_APP_AUTH_PUBLIC_PATH + "/#/edit-campaign?id=" + record.utmCampaign}>ویرایش</Button>}
                    />
                </Datagrid>
            </List>
        </>
    )
}